'use strict';

document.addEventListener('DOMContentLoaded', function() {

  /**
   * パラメータ取得関数
   * URLのクエリ文字列から指定されたパラメータ名に対応する値を取得します。
   * @param {string} name 取得したいパラメータ名
   * @param {string} url 別ページのURLを使用したい場合
   * @returns {string|null} パラメータの値、またはパラメータが存在しない場合はnull
   */
  function getParam(name, url = window.location.search) {
    const params = new URLSearchParams(url);
    const value = params.get(name);
    return value ? sanitizeUrl(value) : null;
  }


  /**
   * エスケープ関数
   * HTMLエスケープ処理を行うための関数です。
   * @param {string} input エスケープしたい文字列
   * @returns {string} エスケープ処理後の文字列
   */
  function sanitizeUrl(input) {
    if (typeof input !== 'string') {
      throw new TypeError('Expected a string');
    }
    return input.replace(/[&'"<>]/g, function(match) {
      return {
        '&': '&amp;',
        "'": '&#x27;',
        '"': '&quot;',
        '<': '&lt;',
        '>': '&gt;',
      }[match];
    });
  }


  /**
   * アンカースクロール
   * @variable headerElement 固定ヘッダーセレクタ
   * @variable headerElement スクロール速度
   */

  let scroll = new SmoothScroll('a[href*="#"]', {
    speedAsDuration: true,
    speed: 500,
    offset: function() {
      const indicator = document.querySelector('.m-category_indicator');
      if (!indicator) return 0;
      
      const indicatorHeight = indicator.offsetHeight;
      const indicatorTop = parseInt(getComputedStyle(indicator).top, 10) || 0;
      
      return indicatorHeight + indicatorTop;
    },
    easing: 'easeInOutQuint'
  });


  /**
   * アクセシビリティを考慮したスライダー
   * https://ja.splidejs.com/
   */
  /*
  <div class="splide js-slider" aria-label="screen-read-name">
    <div class="splide__track">
      <ul class="splide__list">
        <li class="splide__slide"></li>
      </ul>
    </div>
    <div class="splide__arrows">
      <button class="splide__arrow splide__arrow--prev">Prev</button>
      <ul class="splide__pagination"></ul>
      <button class="splide__arrow splide__arrow--next">Next</button>
    </div>
  </div>
  */
  if ( document.querySelector('.js-slider') !== null ) {
    let jsSlider = new Splide('.js-slider', {
      perPage       : 3,      // 1ページの表示数
      perMove       : 1,      // 1度にスライドを何枚移動するか
      speed         : 800,    // 移動時間（ミリ秒単位）
      type          : 'loop', // ループする場合
      interval      : 4000,   // 自動再生の間隔（ミリ秒単位）
      pauseOnHover  : false,  // マウスホバー時に自動再生をストップさせない
      resetProgress : false,  // 自動再生ストップ時、経過時間を破棄せず続行する
      updateOnMove  : true,   // is-activeクラスを移動前に更新する
      gap           : '30px', // スライド間の余白（cssと同様）
      padding       : '50px', // 左右の見切れる幅（cssと同様）
      easing        : 'cubic-bezier(0.25, 1, 0.5, 1)', // 移動アニメーション
      focus         : 'center',

      // インビュー時から自動再生をスタート（拡張機能：splide-extension-intersection.js）
      autoplay: 'pause',
      intersection: {
        inView: {
          autoplay: true,
        },
        outView: {
          autoplay: false,
        },
        once: true, // 一度画面に表示されたら監視を停止する
      },

      // 動き続けるスライダーを実装（拡張機能：splide-extension-auto-scroll.js）
      autoScroll: {
        speed: 1, // 負の値で流れる向きが右へ変更
        pauseOnHover: false,
        pauseOnFocus: false,
      },

      // メディアクエリ設定（初期：751px以上の場合、スライダーを動作させない）
      // mediaQuery: 'min',
      // breakpoints: {
      //   751: {
      //     destroy: true,
      //   },
      // },
    });

    // スライダーに過不足がある場合にスライダーUIを停止・排除する
    jsSlider.on('overflow', function ( isOverflow ) {
      jsSlider.go(0);
      jsSlider.options = {
        arrows    : isOverflow,
        pagination: isOverflow,
        drag      : isOverflow,
        clones    : isOverflow ? undefined : 0,
      };
    } );

    // スライダーを実行
    jsSlider.mount();
    // jsSlider.mount(window.splide.Extensions);

  }


  // 絞り込み検索機能
  function initInterviewFilter() {
    const filterClear = document.getElementById('js-interview-filter-clear');
    const interviewList = document.getElementById('js-interview-list');
    
    if (!interviewList) return;
    
    let activeFilters = {
      channel: [],
      category: [],
      'parent-category': [],
      location: []
    };
    
    // フィルター設定とマッピング
    const filterConfig = {
      channels: ['新卒採用', 'キャリア採用', '高校生採用', '製造契約社員採用'],
      locations: ['名古屋', '東京', '大阪', '知多', '小牧', '石川'],
      categories: {
        '技術・技能系': ['研究開発', '製品設計・開発', '製造技術開発', '設備設計', '生産技術', 'DX', '生産管理', '品質保証', '知的財産', '建築', '工務', '製造'],
        '営業・管理系': ['国内営業', '海外営業', '事業企画管理', '人事', '財務・経理', '法務', '資材']
      }
    };
    
    // ロケーションマッピング
    const locationMapping = {
      '東京': ['東京勤務', '東京'],
      '名古屋': ['名古屋勤務', '名古屋'],
      '大阪': ['大阪勤務', '大阪'],
      '知多': ['知多勤務', '知多'],
      '小牧': ['小牧勤務', '小牧'],
      '石川': ['石川勤務', '石川']
    };
    
    // チャネルマッピング
    const channelMapping = {
      '新卒採用': ['新卒採用'],
      'キャリア採用': ['キャリア採用'],
      '高校生採用': ['高校生採用'],
      '製造契約社員採用': ['製造契約社員採用']
    };
    
    // フィルターボタン生成
    function generateFilterButtons() {
      // 採用区分ボタン生成
      const channelContainer = document.getElementById('js-filter-channels');
      if (channelContainer) {
        filterConfig.channels.forEach(channel => {
          const button = document.createElement('button');
          button.className = 'p-interview_filter_control_btn';
          button.setAttribute('data-filter', 'channel');
          button.setAttribute('data-value', channel);
          button.textContent = channel;
          channelContainer.appendChild(button);
        });
      }
      
      // 勤務地ボタン生成
      const locationContainer = document.getElementById('js-filter-locations');
      if (locationContainer) {
        filterConfig.locations.forEach(location => {
          const button = document.createElement('button');
          button.className = 'p-interview_filter_control_btn';
          button.setAttribute('data-filter', 'location');
          button.setAttribute('data-value', location);
          button.textContent = location;
          locationContainer.appendChild(button);
        });
      }
      
      // カテゴリボタン生成
      const categoryContainer = document.getElementById('js-filter-categories');
      if (categoryContainer) {
        Object.entries(filterConfig.categories).forEach(([parentCategory, childCategories]) => {
          const headingSet = document.createElement('div');
          headingSet.className = 'p-interview_filter_control_headingset';
          
          const heading = document.createElement('p');
          heading.className = 'p-interview_filter_control_heading';
          heading.textContent = parentCategory + '職種';
          headingSet.appendChild(heading);
          
          const allButton = document.createElement('button');
          allButton.className = 'p-interview_filter_control_btn p-interview_filter_control_btn-all';
          allButton.setAttribute('data-filter', 'parent-category');
          allButton.setAttribute('data-value', parentCategory);
          allButton.textContent = parentCategory + ' ALL';
          headingSet.appendChild(allButton);
          
          const btnsContainer = document.createElement('div');
          btnsContainer.className = 'p-interview_filter_control_btns';
          
          childCategories.forEach(category => {
            const button = document.createElement('button');
            button.className = 'p-interview_filter_control_btn';
            button.setAttribute('data-filter', 'category');
            button.setAttribute('data-value', category);
            button.textContent = category;
            btnsContainer.appendChild(button);
          });
          
          headingSet.appendChild(btnsContainer);
          categoryContainer.appendChild(headingSet);
        });
      }
    }
    
    // ボタン生成
    generateFilterButtons();

    
    // イベント委譲でフィルターボタンクリック処理
    document.addEventListener('click', function(e) {
      if (e.target.matches('.p-interview_filter_control_btn[data-filter]')) {
        const filterType = e.target.getAttribute('data-filter');
        const filterValue = e.target.getAttribute('data-value');
        
        // is-selectedクラスのトグル
        e.target.classList.toggle('is-selected');
        
        // 親カテゴリの場合は子カテゴリも制御
        if (filterType === 'parent-category') {
          handleParentCategoryFilter(filterValue, e.target.classList.contains('is-selected'));
        }
        
        updateActiveFilters();
        filterInterviewItems();
      }
    });
    
    // 親カテゴリフィルター処理
    function handleParentCategoryFilter(parentValue, isSelected) {
      const categoryButtons = document.querySelectorAll('.p-interview_filter_control_btn[data-filter="category"]');
      
      categoryButtons.forEach(btn => {
        const itemCategory = btn.getAttribute('data-value');
        const parentCategory = getParentCategory(itemCategory);
        
        if (parentCategory === parentValue) {
          if (isSelected) {
            btn.classList.add('is-selected');
          } else {
            btn.classList.remove('is-selected');
          }
        }
      });
    }
    
    // カテゴリから親カテゴリを取得
    function getParentCategory(category) {
      const techCategories = ['研究開発', '製品設計・開発', '製造技術開発', '設備設計', '生産技術', 'DX', '生産管理', '品質保証', '知的財産', '建築', '工務', '製造'];
      const salesCategories = ['国内営業', '海外営業', '事業企画管理', '人事', '財務・経理', '法務', '資材'];
      
      if (techCategories.includes(category)) {
        return '技術・技能系';
      } else if (salesCategories.includes(category)) {
        return '営業・管理系';
      }
      return '';
    }
    
    // アクティブフィルターを更新
    function updateActiveFilters() {
      Object.keys(activeFilters).forEach(key => {
        activeFilters[key] = [];
      });
      
      const filterButtons = document.querySelectorAll('.p-interview_filter_control_btn[data-filter]');
      filterButtons.forEach(button => {
        if (button.classList.contains('is-selected')) {
          const filterType = button.getAttribute('data-filter');
          const filterValue = button.getAttribute('data-value');
          
          if (filterType !== 'parent-category') {
            activeFilters[filterType].push(filterValue);
          }
        }
      });
    }
    
    // インタビューアイテムの絞り込み
    function filterInterviewItems() {
      const items = interviewList.querySelectorAll('.p-interview_list_item');
      let visibleCount = 0;
      
      items.forEach(item => {
        let showItem = true;
        
        // チャネルフィルター
        if (activeFilters.channel.length > 0) {
          const itemChannel = item.querySelector('.p-interview_list_item_segment_channel')?.textContent.trim();
          let channelMatch = false;
          
          activeFilters.channel.forEach(channel => {
            const mappedChannels = channelMapping[channel] || [channel];
            if (mappedChannels.some(mapped => itemChannel && itemChannel.includes(mapped))) {
              channelMatch = true;
            }
          });
          
          if (!channelMatch) showItem = false;
        }
        
        // カテゴリフィルター
        if (activeFilters.category.length > 0) {
          const itemCategory = item.querySelector('.p-interview_list_item_info_childCategory')?.textContent.trim();
          if (!activeFilters.category.includes(itemCategory)) {
            showItem = false;
          }
        }
        
        // ロケーションフィルター
        if (activeFilters.location.length > 0) {
          const itemLocation = item.querySelector('.p-interview_list_item_segment_location')?.textContent.trim();
          let locationMatch = false;
          
          activeFilters.location.forEach(location => {
            const mappedLocations = locationMapping[location] || [location];
            if (mappedLocations.some(mapped => itemLocation && itemLocation.includes(mapped))) {
              locationMatch = true;
            }
          });
          
          if (!locationMatch) showItem = false;
        }
        
        // アイテム表示/非表示
        if (showItem) {
          item.style.display = '';
          item.classList.remove('is-hidden');
          visibleCount++;
        } else {
          item.style.display = 'none';
          item.classList.add('is-hidden');
        }
      });
      
      // 結果数を更新
      updateResultCount(visibleCount);
    }
    
    // 結果数表示更新
    function updateResultCount(count) {
      const recordElement = document.getElementById('js-interview-record');
      if (recordElement) {
        // フェードアウト
        recordElement.style.transition = 'opacity 0.2s ease-out, transform 0.2s ease-out';
        recordElement.style.opacity = '0';
        recordElement.style.transform = 'translateY(-10px)';
        
        // 数字を更新してフェードイン
        setTimeout(() => {
          recordElement.textContent = String(count).padStart(2, '0');
          recordElement.style.opacity = '1';
          recordElement.style.transform = 'translateY(0)';
        }, 100);
      }
    }
    
    // クリアボタン処理
    if (filterClear) {
      filterClear.addEventListener('click', function() {
        const filterButtons = document.querySelectorAll('.p-interview_filter_control_btn[data-filter]');
        filterButtons.forEach(button => {
          button.classList.remove('is-selected');
        });
        
        Object.keys(activeFilters).forEach(key => {
          activeFilters[key] = [];
        });
        
        filterInterviewItems();
      });
    }
  }
  
  // インタビューページでのみ初期化
  if (document.querySelector('.p-interview_filter')) {
    initInterviewFilter();
    
    // 初期表示時の結果数を設定
    window.addEventListener('load', function() {
      const interviewList = document.getElementById('js-interview-list');
      if (interviewList) {
        const items = interviewList.querySelectorAll('.p-interview_list_item');
        const recordElement = document.getElementById('js-interview-record');
        if (recordElement) {
          recordElement.textContent = String(items.length).padStart(2, '0');
        }
      }
    });
  }

});


(function($) {
    var navItem = $(".l-header_nav_item");
    var navSub = $(".l-header_nav_sub_wrap"); 
    var navClose = $(".l-header_nav_sub_close");
    var header = $(".l-header");
    var navHamburger = $('.l-header_hamburger');
    var navTrigger = $('#l-header_sp_trigger'); 
    var html = $('html');

    // サブメニューを閉じる
    function closeAllNavi(sub, item){
        if(sub){
            navSub.not(sub).slideUp().removeClass('is-active');
            navItem.not(item).removeClass('is-active');
            navItem.not(item).find('.l-header_nav_link').attr('aria-expanded', false);
            navItem.not(item).find('.l-header_nav_sub_wrap').attr('aria-hidden', true); 
        } else{
            navSub.slideUp().removeClass('is-active');
            navItem.removeClass('is-active');
            navItem.find('.l-header_nav_link').attr('aria-expanded', false);
            navItem.find('.l-header_nav_sub_wrap').attr('aria-hidden', true); 
            header.removeClass('is-nav-opened');
            
            navHamburger.removeClass('is-active');
            navTrigger.removeClass('is-opened').hide();
            html.removeClass('is-nav-opened');
            navTrigger.attr('aria-hidden', true);
            $('.l-header_hamburger_link').attr('aria-expanded', false);
        }
    }

  // PC/SP共通: グローバルナビゲーション処理
  function initGlobalNav() {
    // aria属性の初期設定
    navSub.each(function(i){
        $(this).closest('li').addClass('has-sub');
        $(this).closest('li').find('.l-header_nav_link').attr('aria-expanded', false);
        $(this).attr('aria-hidden', true);
        $(this).closest('li').find('.l-header_nav_link').attr('aria-controls', 'nav-menu-' + i);
        $(this).attr('id', 'nav-menu-' + i);
    });

    // 閉じるボタン
    navClose.on('click', function(e){
        e.preventDefault();
        closeAllNavi();
    });

    // リサイズ時の処理
    var current = window.innerWidth < 780 ? 'sp' : 'pc';
    var timerR = false;
    $(window).resize(function(){
        var checkDeviceSize = window.innerWidth < 780 ? 'sp' : 'pc';
        if(timerR) clearTimeout(timerR);
        timerR = setTimeout(function(){
            if(checkDeviceSize != current){
                closeAllNavi();
                current = checkDeviceSize;
            }
        }, 200);
    });

    // サブメニューのクリック処理
    navItem.each(function(i, elem){
        var elem = $(elem);
        var anchor = elem.find('.l-header_nav_link');
        var sub = elem.find('.l-header_nav_sub_wrap'); 

        if(sub.length){
            anchor.on('click', function(e){
                e.preventDefault();
                // PCのみ他のサブメニューを閉じる
                if(window.innerWidth > 780){
                    closeAllNavi(sub, elem);
                }
                elem.toggleClass('is-active');
                if(elem.hasClass('is-active')){
                    if(window.innerWidth > 780){
                        // PC: 左からスライド（CSSアニメーション）
                        sub.css('display', 'flex'); // 先に表示
                        requestAnimationFrame(function(){ 
                            sub.addClass('is-active');
                        });
                    } else {
                        // SP: 上からスライド
                        sub.slideDown(300).addClass('is-active');
                    }
                } else{
                    if(window.innerWidth > 780){
                        // PC: 左へスライド
                        sub.removeClass('is-active');
                    } else {
                        // SP: 上へスライド
                        sub.slideUp(300).removeClass('is-active');
                    }
                }
                anchor.attr('aria-expanded', elem.hasClass('is-active'));
                sub.attr('aria-hidden', !elem.hasClass('is-active'));
                
                if($(".l-header_nav_sub_wrap.is-active").length){ 
                    header.addClass('is-nav-opened');
                } else{
                    header.removeClass('is-nav-opened');
                }
            });
        }
    });

    // 外側クリックで閉じる
    $(document).on('click', function(e){
        if(!$(e.target).closest('.l-header').length){
            closeAllNavi();
        }
    });

    // ESCキーで閉じる
    $(document).keyup(function(e) {
        if (e.keyCode === 27) {
            closeAllNavi();
        }
    });
  }

  // SP: ハンバーガーメニュー処理
  function initHamburgerMenu() {
    navHamburger.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // トグル処理
        $(this).toggleClass('is-active');
        navTrigger.toggleClass('is-opened');
        
        if(navTrigger.hasClass('is-opened')){
            navTrigger.slideDown(300);
            html.addClass('is-nav-opened');
        } else {
            navTrigger.slideUp(300);
            html.removeClass('is-nav-opened');
        }
        
        // aria属性更新
        var isOpen = navTrigger.hasClass('is-opened');
        $(this).find('.l-header_hamburger_link').attr('aria-expanded', isOpen); 
        navTrigger.attr('aria-hidden', !isOpen);
    });
    
    // 外側クリックで閉じる
    $(document).on('click', function(e){
        if(!$(e.target).closest('.l-header, #l-header_sp_trigger').length){ 
            navHamburger.removeClass('is-active');
            navTrigger.removeClass('is-opened').slideUp(300);
            html.removeClass('is-nav-opened');
            navTrigger.attr('aria-hidden', true);
        }
    });
    
    // ESCキーで閉じる
    $(document).keyup(function(e) {
        if (e.keyCode === 27) {
            navHamburger.removeClass('is-active');
            navTrigger.removeClass('is-opened').slideUp(300);
            html.removeClass('is-nav-opened');
            navTrigger.attr('aria-hidden', true);
        }
    });
  }

  // SP: サブメニューのアコーディオン
  function initSPSubMenu() {
    var spSubItem = $('.l-header_nav_sub_item_sp');
    var spSubChild = $('.l-header_nav_sub_child_list_sp');
    
    // aria属性の初期設定
    spSubChild.each(function(i){
        $(this).closest('li').addClass('has-sub');
        $(this).closest('li').find('.l-header_nav_sub_link_sp').attr('aria-expanded', false);
        $(this).attr('aria-hidden', true);
        $(this).closest('li').find('.l-header_nav_sub_link_sp').attr('aria-controls', 'sp-sub-menu-' + i);
        $(this).attr('id', 'sp-sub-menu-' + i);
    });
    
    spSubItem.each(function(i, elem) {
        var elem = $(elem);
        var anchor = elem.find('.l-header_nav_sub_link_sp');
        var childList = elem.find('.l-header_nav_sub_child_list_sp');
        
        if(childList.length) {
            anchor.on('click', function(e) {
                e.preventDefault();
                
                elem.toggleClass('is-active');
                
                if(elem.hasClass('is-active')) {
                    childList.slideDown(300);
                } else {
                    childList.slideUp(300);
                }
                
                anchor.attr('aria-expanded', elem.hasClass('is-active'));
                childList.attr('aria-hidden', !elem.hasClass('is-active'));
            });
        }
    });
  }

  // 初期化
  $(function(){
      initGlobalNav();
      initHamburgerMenu();
      initSPSubMenu();
      $(window).on('pageshow', function(e) {
          if (e.originalEvent.persisted) {
              closeAllNavi();
          }
      });
  });
})(jQuery);


$('.m-faq_list_question').on('click', function () {
  $(this).next('.m-faq_list_answer').slideToggle(300);
  $(this).toggleClass('is-open');
  if ($(this).hasClass('is-open')) {
    $(this).attr('aria-expanded', 'true');
  } else {
    $(this).attr('aria-expanded', 'false');
  }
});


// 英語タイトルの文字サイズの自動調整
function fitText(element) {
  const wrapper = element.parentElement;
  
  element.style.fontSize = '';
  
  let fontSize = parseFloat(getComputedStyle(element).fontSize);
  
  // はみ出てる間はフォントサイズを下げる
  while (element.scrollWidth > wrapper.clientWidth && fontSize > 10) {
    fontSize -= 1;
    element.style.fontSize = fontSize + 'px';
  }
}

document.querySelectorAll('.m-title_lv2:not(.m-title_lv2--type2) .m-title_lv2_en').forEach(el => fitText(el));
window.addEventListener('resize', () => {
  document.querySelectorAll('.m-title_lv2:not(.m-title_lv2--type2) .m-title_lv2_en').forEach(el => fitText(el));
});